/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonAddressSummaryInfo } from './BabylonAddressSummaryInfo';
import type { BabylonFinalityProviderSummaryInfo } from './BabylonFinalityProviderSummaryInfo';

export type BabylonBtcStakingTrxInfo = {
    STAT: BabylonBtcStakingTrxInfo.STAT;
    TRXHA: string;
    STK: BabylonAddressSummaryInfo;
    AMT: string;
    VAL: string;
    FPRVDLIST: Array<BabylonFinalityProviderSummaryInfo>;
    PRD: string;
    AGE: string;
    UT: number;
};

export namespace BabylonBtcStakingTrxInfo {

    export enum STAT {
        PENDING = 'PENDING',
        VERIFIED = 'VERIFIED',
        ACTIVE = 'ACTIVE',
        UNBONDING = 'UNBONDING',
        WITHDRAWABLE = 'WITHDRAWABLE',
        WITHDRAWN = 'WITHDRAWN',
        UNBONDED = 'UNBONDED',
        EXPIRED = 'EXPIRED',
        EXPANDED = 'EXPANDED',
        SLASHED = 'SLASHED',
    }


}

